export const theme = {
    colors: {
        justBlack: '#000',
        clearlyWhite: '#fff',
        almostWhite: '#e2e5e5',
        kindaBlue: '#07c',
        purpleIsh: '#609',
        notPink: '#cf948b',
        ohSoOrange: '#ff9f33',
        almostDarkGreen: '#082911',
        maybeYellow: '#decea9',
        midnightGrey: '#686868',
        reallyBisque: 'bisque',
        cherryRed: '#6d031c',
        tastyCoffe: '#a79086',
    },
    space: [0, 2, 4, 8, 16, 32, 64, 128, 256],
    fonts: {
        body: 'system-ui, sans-serif',
        heading: 'system-ui, sans-serif',
        monospace: 'Menlo, monospace',
    },
    fontSizes: {
        xs: '12px',
        s: '14px',
        m: '16px',
        l: '32px',
        xl: '64px',
    },
    fontWeights: {
        normal: 400,
        medium: 500,
        bold: 700,
    },
    lineHeights: {
        body: 1.5,
        heading: 1.125,
    },
    borders: {
        none: 'none',
        normal: '2px solid',
        medium: '6px solid',
    },
    radii: {
        none: '0',
        sm: '4px',
        md: '8px',
        lg: '16px',
        round: '50%',
    },
    shadows: {
        shadowFirst: '0 4px 4px rgba(0, 0, 0, .25)',
        shadowSecond: '0px 5px 10px bisque',
    },
    transition: {
        cubicBezier: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',
    },
    transform: {
        scaleFirst: 'scale(1.07)',
        scaleSecond: 'scale(1.1)',
        scaleThird: 'scale(1.15)',
    },
};